import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button as MuiButton, Stack, } from '@mui/material';
import { styled } from '@mui/material/styles';
import { forwardRef } from 'react';
// TODO replace with new one
import { CircularProgress, Link } from '../../legacy/components';
import { useTheme } from '../../theme';
import { Icon } from '../Icon';
import { Typography } from '../Typography';
const StyledButton = styled(MuiButton, {
    shouldForwardProp: (prop) => !String(prop).startsWith('$'),
})(({ theme, $buttonSize, $autoHeight, $round, $hasIcon, $sizeStyles, $variantStyles, }) => ({
    ...$variantStyles,
    ...$sizeStyles,
    padding: 
    // TODO
    // variant === 'link' ? '0' :
    $buttonSize === 'large' || $buttonSize === 'x-large'
        ? '8px 24px'
        : '8px 16px',
    textAlign: 'left',
    maxWidth: 'fit-content',
    '&.MuiButtonBase-root': {
        height: $autoHeight ? 'auto' : 'fit-content',
        ...($round
            ? {
                borderRadius: '50%',
                minHeight: '45px',
                maxHeight: '45px',
                maxWidth: '30px',
                minWidth: '30px',
            }
            : {}),
    },
    [theme.breakpoints.down('sm')]: {
        minWidth: $hasIcon ? 'fit-content' : 'initial',
        padding: 
        // TODO variant === 'link' ? '0' :
        '8px 16px',
        '& .MuiTypography-root': {
            fontSize: $buttonSize === 'large' || $buttonSize === 'x-large'
                ? '16px'
                : $buttonSize === 'medium'
                    ? '14px'
                    : '13px',
            lineHeight: '20px',
        },
    },
}));
export const Button = forwardRef(function Button({ children, disabled, loading, onClick, size = 'medium', variant = 'contained', icon, dataName, value, href, className, autoHeight = true, round = false, }, ref) {
    const { sizes, variants } = useTheme().components?.DSButton ?? {};
    const containerizedChildren = typeof children === 'string' ? (_jsx(Typography, { color: "inherit", variant: "button", children: children })) : (children);
    const childrenWithIcon = loading || icon ? (_jsxs(Stack, { direction: "row", spacing: 102, alignItems: "center", children: [icon && (_jsx(Icon, { size: size === 'small' ? 'small' : 'medium', variant: icon })), loading && (_jsx(CircularProgress, { size: sizes?.[size]?.iconSize, color: "inherit" })), containerizedChildren] })) : (containerizedChildren);
    const childrenWithLink = href ? (_jsx(Link, { variant: "body1", color: "inherit", href: href, children: childrenWithIcon })) : (childrenWithIcon);
    return (_jsx(StyledButton, { value: value, "data-name": dataName, disabled: disabled, onClick: onClick, ref: ref, variant: variant, disableRipple: variant === 'text', className: className, $buttonSize: size, $variantName: variant, $autoHeight: autoHeight, $round: round, $hasIcon: Boolean(icon), $sizeStyles: sizes?.[size], $variantStyles: variants?.[variant], children: childrenWithLink }));
});
